import axios from "../../config/axiosConfig";
import {
  GSTR1_REPORT_REQUEST,
  GSTR1_REPORT_SUCCESS,
  GSTR1_REPORT_FAILURE,
} from "../types/gstr1-report-types";

export const getGSTR1Report = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GSTR1_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };
    
      const requestParams = { ...defaultParams, ...params };
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/gstr1-report/getReport?${queryString}`;
      console.log('Complete GSTR1 API Request URL: ', fullUrl);
      return axios.get('/gstr1-report/getReport', { params: requestParams }).then((response) => {
        if (response) {
          dispatch({ 
            type: GSTR1_REPORT_SUCCESS, 
            payload: response 
          });
          console.log("Actions Api Call" , response);
          
          return response;
        } else {
          throw new Error(response.data?.message || 'Failed to fetch GSTR1 report');
        }
      }).catch((error) => {
        console.error("Error fetching GSTR1 Report:", error);
        dispatch({ 
          type: GSTR1_REPORT_FAILURE, 
          error: error.response?.data?.message || error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error("Error fetching GSTR1 Report:", error);
      dispatch({ 
        type: GSTR1_REPORT_FAILURE, 
        error: error.response?.data?.message || error.message 
      });
      throw error;
    }
  };
};
